<nav class="breadcrumbs_container" data-crlat="breadcrumbsContainer">
    <ul class="breadcrumbs clearfix">
        @for (linkItem of items; track trackByBreadcrumb(linkItem); let last = $last) {
            <li class="breadcrumb_item" [attr.title]="linkItem.name" data-crlat="breadcrumb.item">
                @if (!last) {
                    <a
                        class="breadcrumb_link"
                        (click)="navigateUri($event, linkItem.targetUri)"
                        [attr.href]="linkItem.targetUri"
                        [textContent]="linkItem.name"
                        data-crlat="breadcrumb.link">
                    </a>
                } @else {
                    <span (click)="lastItemClick()" data-crlat="meetingSelector">
                        <span class="breadcrumb_link" [textContent]="linkItem.name" data-crlat="breadcrumb.link"> </span>
                        @if (menuItems && menuItems.length) {
                            <span class="toggle-icon" data-crlat="toggleIcon" [ngClass]="{ active: isExpanded }">
                                <svg>
                                    <use xlink:href="#down-arrow"></use>
                                </svg>
                            </span>
                        }
                    </span>
                }
            </li>
        }
    </ul>
</nav>
